import { render, staticRenderFns } from "./UnitAuthern.vue?vue&type=template&id=16c0d6b2&scoped=true&"
import script from "./UnitAuthern.vue?vue&type=script&lang=ts&"
export * from "./UnitAuthern.vue?vue&type=script&lang=ts&"
import style0 from "./UnitAuthern.vue?vue&type=style&index=0&id=16c0d6b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0d6b2",
  null
  
)

export default component.exports